import {
  Body,
  Controller,
  Delete,
  Get,
  Param,
  Post,
  Query,
  UseGuards,
} from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { RequireModule, RequirePermission } from '../../auth/decorators';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import { GetUser } from '../../auth/get-user.decorator';
import { CrearCampanaDto, FiltrosCampanaDto } from '../dto/campana.dto';
import { CampanasService } from './campanas.service';

@ApiTags('Cartera Inteligente — Campañas')
@ApiBearerAuth()
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('COBRANZAS')
@Controller({ path: 'cartera/campanas', version: '1' })
export class CampanasController {
  constructor(private readonly service: CampanasService) {}

  @Post('preview')
  @RequirePermission('COBRANZAS', 'COB_CART_VER')
  @ApiOperation({ summary: 'Preview de cuántos clientes recibirían la campaña' })
  preview(@Body() filtros: FiltrosCampanaDto, @GetUser() user: LoginUserInfo) {
    return this.service.preview(user.empresa_id, filtros);
  }

  @Post()
  @RequirePermission('COBRANZAS', 'COB_CART_CONFIGURAR')
  @ApiOperation({ summary: 'Crear y disparar campaña masiva' })
  crear(@Body() dto: CrearCampanaDto, @GetUser() user: LoginUserInfo) {
    return this.service.crear(user.empresa_id, user.id, dto);
  }

  @Get()
  @RequirePermission('COBRANZAS', 'COB_CART_VER')
  @ApiOperation({ summary: 'Listar campañas recientes' })
  listar(@GetUser() user: LoginUserInfo) {
    return this.service.listar(user.empresa_id);
  }

  @Get(':id')
  @RequirePermission('COBRANZAS', 'COB_CART_VER')
  @ApiOperation({ summary: 'Detalle de campaña + envíos' })
  detalle(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.detalle(user.empresa_id, id);
  }

  @Delete(':id')
  @RequirePermission('COBRANZAS', 'COB_CART_CONFIGURAR')
  @ApiOperation({ summary: 'Cancelar envíos pendientes de una campaña' })
  cancelar(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.cancelar(user.empresa_id, id);
  }
}
